import axiosInstance from '../../../config/axiosInstance';
import { SupplierHistoryValidation } from "../View/Validation/SupplierHistoryValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};
const handleSubmit = async (
    event,
    formData,
    setFormData,
    setErrors,
    pdfAttachment
) => {

    const formErrors = SupplierHistoryValidation(formData);
    setErrors(formErrors);
    debugger;
    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            const formDataToSend = new FormData();
            formDataToSend.append('ClientID', CompanyID);
            formDataToSend.append('UserID', UserID);
            // ✅ Append only primitive values
            Object.keys(formData).forEach(key => {
                if (key !== 'File') { // Skip the File key, we will handle it separately
                    formDataToSend.append(key, formData[key]);
                }
            });
            if (formData.File) {
                formDataToSend.append('Attachment', formData.File);
            }




            // ✅ Append file properly
            if (pdfAttachment?.file instanceof File) {
                formDataToSend.append("Attachment", pdfAttachment.file);

            }

            // 🔍 Debugging

            console.log("pdfAttachment:", pdfAttachment);
            console.log("Is File:", pdfAttachment?.file instanceof File);
            debugger;

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };


            const response = await axiosInstance.post(`/Supplier/CreateSupplierHistory`, formDataToSend, config);


            return response;

        } catch (error) {
            console.error('Error posting data:', error);
        }
    }
};

export { handleChange, handleSubmit };
